var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_114",
    "data-name": "Caminho 114",
    d: "M12,2A10.133,10.133,0,0,0,2,12,10.133,10.133,0,0,0,12,22,10.133,10.133,0,0,0,22,12,10.133,10.133,0,0,0,12,2Zm0,5a2.914,2.914,0,0,1,3,3,2.914,2.914,0,0,1-3,3,2.915,2.915,0,0,1-3-3A2.915,2.915,0,0,1,12,7ZM6.894,16.772A4.959,4.959,0,0,1,11,14.572h2a4.958,4.958,0,0,1,4.106,2.2,6.965,6.965,0,0,1-10.212,0Z",
    transform: "translate(-2 -2)",
    fill: "#2e2e36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.c52392e0df8df76a4de199fedd67ffb1.svg";
export { ForwardRef as ReactComponent };